import React, { useRef } from 'react'
import styled from 'styled-components'
import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'

SwiperCore.use([Navigation])

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 5px 0;

  & .swiper-wrapper {
    display: flex !important;
    transition-property: transform !important;
    box-sizing: content-box;
  }

  & .swiper-slide {
    flex-shrink: 0 !important;
    box-sizing: border-box;
    flex: 0 0 auto !important;
    align-self: flex-start !important;
  }

  & .swiper-button-disabled {
    display: none;
  }
`
const NavButton = styled.button<{ side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ side }) => side}: 8px;
  transform: translateY(-50%);
  z-index: 10;
  background: ${Colors.Neutral15};
  color: ${Colors.Neutral50};
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
`

export default function Carousel(props: { children: React.ReactNode[] }) {
  const containerRef = useRef<HTMLDivElement>(null)

  if (props.children.length === 0) return null

  return (
    <CarouselContainer ref={containerRef}>
      <NavButton side="left" id="prev-slide" aria-label="Previous slide">
        <Icon24.ChevronLeft />
      </NavButton>
      <NavButton side="right" id="next-slide" aria-label="Next slide">
        <Icon24.ChevronRight />
      </NavButton>
      <Swiper
        loop={false}
        roundLengths={true}
        loopedSlides={props.children.length}
        direction="horizontal"
        slidesPerView="auto"
        spaceBetween={24}
        navigation={{
          prevEl: '#prev-slide',
          nextEl: '#next-slide',
        }}
        onSlideChange={() => {
          containerRef.current?.querySelectorAll('article').forEach(cardEl => {
            cardEl.dispatchEvent(new Event('recomputeOrigin'))
          })
        }}
      >
        {props.children.map((child, idx) => {
          return (
            <SwiperSlide key={idx}>
              {React.cloneElement(child as React.ReactElement, { containerRef })}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </CarouselContainer>
  )
}
